
import { defineComponent, PropType, computed } from 'vue'
import { DoctorReportLorealMarkData } from '../types'
import { DOCTOR_REPORT_LOREAL_MARK_INFO, DOCTOR_REPORT_LOREAL_MARK_TOOLTIPS } from '../consts'
import get from 'lodash/get'

export default defineComponent({
    props: {
        markData: { type: Object as PropType<DoctorReportLorealMarkData>, required: true },
    },
    setup(props) {
        const parseComparableNumber = (value: string | number | null | undefined): number | null => {
            if (value === null || value === undefined) return null
            if (typeof value === 'number') return Number.isFinite(value) ? value : null
            const normalized = value.replace('%', '').replace(',', '.').trim()
            const parsed = parseFloat(normalized)
            return Number.isFinite(parsed) ? parsed : null
        }

        const getRatioMarkType = (
            currentValue: string | number | null | undefined,
            compareValue: string | number | null | undefined,
            fallback: 'low' | 'medium' | 'high'
        ): 'low' | 'medium' | 'high' => {
            const currentNumber = parseComparableNumber(currentValue)
            const compareNumber = parseComparableNumber(compareValue)

            if (currentNumber === null || compareNumber === null || compareNumber <= 0) {
                return fallback
            }

            const ratio = (currentNumber / compareNumber) * 100
            if (ratio >= 90) return 'high'
            if (ratio >= 50) return 'medium'
            return 'low'
        }

        const getLegacyMarkType = (value: string | number | null | undefined): 'low' | 'medium' | 'high' => {
            const markInfo = get(DOCTOR_REPORT_LOREAL_MARK_INFO, props.markData.id)
            if (value === null || value === undefined || !markInfo) return 'low'
            if (parseFloat(String(value)) >= parseFloat(markInfo.high.value)) return 'high'
            if (parseFloat(String(value)) >= parseFloat(markInfo.medium.value)) return 'medium'
            return 'low'
        }

        const markType = computed(() => {
            const fallback = getLegacyMarkType(props.markData.value)
            return getRatioMarkType(props.markData.value, props.markData.compareValue, fallback)
        })

        const monthMarkType = computed(() => {
            const fallback = getLegacyMarkType(props.markData.quarterValue)
            return getRatioMarkType(props.markData.quarterValue, props.markData.quarterCompareValue, fallback)
        })

        const icon = computed(() => {
            if (markType.value === 'high') return '$greenGradientCheckmark'
            if (markType.value === 'medium') return '$yellowGradientWarning'
            if (markType.value === 'low') return '$redGradientLightning'
        })

        const tooltipText = computed(() => {
            return DOCTOR_REPORT_LOREAL_MARK_TOOLTIPS[props.markData.id] || props.markData[markType.value].markText
        })

        const showIcon = computed(() => {
            // Показываем иконки только для определенных типов карточек
            const iconCards = [
                'conversion2', 'conversion3', 'conversion2Parik', 'conversion3Parik',
                'itemsCount', 'itemsCountParik', 'newCountByMonth', 'newCountByMonthParikAbsolute', 'newCountByMonthParikCross'
            ]
            return iconCards.includes(props.markData.id)
        })

        const prettifyValue = (value: string | number | null) => {
            if (value === null || value === undefined) return 0
            return String(value).replaceAll('.', ',')
        }

        return {
            markType,
            monthMarkType,
            icon,
            tooltipText,
            showIcon,
            prettifyValue,
        }
    },
})
